var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isValid)?_c('img',{staticClass:"map",attrs:{"src":_vm.sourceMap}}):_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t("campaigns.data-bank.location.error-map"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }